/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Deliverydelay_Name1Inputs */

const en_resources_deliverydelay_name1 = /** @type {(inputs: Resources_Deliverydelay_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delayed orders`)
};

const fr_resources_deliverydelay_name1 = /** @type {(inputs: Resources_Deliverydelay_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes décalées`)
};

const es_resources_deliverydelay_name1 = /** @type {(inputs: Resources_Deliverydelay_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos retrasados`)
};

const de_resources_deliverydelay_name1 = /** @type {(inputs: Resources_Deliverydelay_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verspätete Bestellungen`)
};

const nl_resources_deliverydelay_name1 = /** @type {(inputs: Resources_Deliverydelay_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertraagde bestellingen`)
};

/**
* | output |
* | --- |
* | "Delayed orders" |
*
* @param {Resources_Deliverydelay_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_deliverydelay_name1 = /** @type {((inputs?: Resources_Deliverydelay_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Deliverydelay_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_deliverydelay_name1(inputs)
	if (locale === "fr") return fr_resources_deliverydelay_name1(inputs)
	if (locale === "es") return es_resources_deliverydelay_name1(inputs)
	if (locale === "de") return de_resources_deliverydelay_name1(inputs)
	return nl_resources_deliverydelay_name1(inputs)
});
export { resources_deliverydelay_name1 as "resources.deliveryDelay.name" }